import TableCell from '@mui/material/TableCell'
import { Checkbox, TableSortLabel } from '@mui/material'
import React, { ReactElement } from 'react'
import { ColumnDefinition } from './Table'

export const sorterHeader = (col: ColumnDefinition<any>, sort: any, setSort: (sort: any) => void): ReactElement => {
    let sortField = col.sortField || col.key
    return col.sorter ? (
        <TableCell style={{ fontWeight: 700, ...col.style }} key={`header-${col.key ? col.key.toString() : col.title}`}
                   sortDirection={sort && sort.field === sortField ? sort.order : false}>
            <TableSortLabel
                active={sort && sort.field === sortField}
                direction={sort && sort.field === sortField ? sort.order : 'asc'}
                onClick={() =>
                    setSort({
                        field: sortField,
                        order: sort && sort.field === sortField && sort.order === 'asc' ? 'desc' : 'asc',
                    })
                }
            >
                {col.title}
            </TableSortLabel>
        </TableCell>
    ) : (
        <TableCell style={{ fontWeight: 700, ...col.style }} key={`header-${col.key ? col.key.toString() : col.title}`}>
            {!!col.checkbox ? <Checkbox value={col.checkbox.selected} onChange={() => col.checkbox?.setSelected(!col.checkbox?.selected)}></Checkbox> : col.title}
        </TableCell>
    )
}
